// extracted by mini-css-extract-plugin
module.exports = {"container":"TextEditor_container__3WEOY"};